<template>
    <div>
        <headerNotice routerName="添加话题"></headerNotice>
        <!-- 基本信息 -->
        <div class="baseInfo" v-loading="loading">
            <h1>
                基本信息
                <span>
                    （&nbsp;
                    <i class="mustStar">*</i>&nbsp;必填）
                </span>
            </h1>
            <div class="table">
                <el-form :model="formData" class="signUp_Form" label-width="200px">
                    <el-row>
                        <el-col :span="10">
                            <el-form-item label="标题：" :rules="{'required':true}">
                                <el-input
                                    v-model="formData.title"
                                    size="small"
                                    placeholder="请输入商品名称，小于50个字"
                                    maxlength="50"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10">
                            <el-form-item label="分类：" :rules="{'required':true}">
                                <el-select v-model="formData.cate" placeholder="请选择分类">
                                     <el-option
                                    v-for="item in cateList"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="10">
                            <el-form-item label="类型：" :rules="{'required':true}">
                                <el-select v-model="formData.type" placeholder="请选择类型">
                                    <el-option
                                        v-for="item in typeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                                        <el-row>
                        <el-col :span="15">
                            <el-form-item label="排序">
                                <el-input
                                    class="inputStyle"
                                    v-model="formData.sort"
                                    maxlength="50"
                                    size="small"
                                    placeholder="请输入"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="24">
                        <el-col :span="8">
                            <el-form-item label="状态：">
                                <el-switch
                                    v-model="formData.status"
                                    :active-value="1"
                                    :inactive-value="0"
                                    active-text="上线"
                                    inactive-text="下线"
                                ></el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </div>    
              <h1>企业名称</h1>
            <div class="linkIpt">
                <el-input  autosize v-model="formData.entName" placeholder="请输入企业名称"></el-input>
            </div>
             <h1>企业说明</h1>
            <div class="linkIpt">
                <el-input  type="textarea" autosize v-model="formData.entDescription" placeholder="请输入企业说明"></el-input>
            </div>               
            <h1>企业图片</h1>
            <div class="goodsBox">
                <el-row>
                    <el-col>
                        <el-upload
                            :accept='accept'
                            :headers="headers"
                            class="upload-demo"
                            :action="uploadAction"
                            :on-success="handleGoodsImgstSuccess"
                            list-type="picture-card"
                            :file-list="goodsImagesList"
                            :before-upload="beforeUpload"
                            :on-remove="handleGoodsImgstRemove"
                        >
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-col>
                </el-row>
            </div>
            <h1>话题图片</h1>
            <div class="goodsBox">
                <el-row>
                    <el-col>
                        <el-upload
                            :accept='accept'
                            :headers="headers"
                            class="upload-demo"
                            :action="uploadAction"
                            :on-success="handleGoodsDescripImgstSuccess"
                            :file-list="goodsDescripImagesList"
                            list-type="picture-card"
                            :before-upload="beforeUpload"
                            :on-remove="handleGoodsDescripImgstRemove"
                        >
                            <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                    </el-col>
                </el-row>
            </div>
            <h1>跳转类型</h1>
            <div class="linkIpt">
               <el-radio-group   v-model="formData.productLinkType"  style='margin-right: 120px;'>
                <el-radio-button :label="1">试用产品</el-radio-button>
                <el-radio-button :label="2">第三方链接</el-radio-button>
                </el-radio-group>

            </div>
            <h1>产品链接</h1>
            <div class="linkIpt">
                <el-input v-model="formData.productLink" placeholder="请输入产品链接地址"></el-input>
            </div>
             <h1 v-if="formData.productLinkType==2">第三方appid</h1>
            <div class="linkIpt"  v-if="formData.productLinkType==2">
                <el-input v-model="formData.appID" placeholder="请输入appid"></el-input>
            </div>
                        <h1>产品链接描述</h1>
            <div class="linkIpt">
                <el-input v-model="formData.productDescribe" placeholder="请输入产品链接地址"></el-input>
            </div>
             <h1>话题内容</h1>
               <div class="linkIpt">
                    <v-editor
                        class="editor"
                        :value="formData.contents"
                        @getContent="(content) => formData.contents = content"
                    ></v-editor>
                     </div>
            <!-- 保存 -->
            <div class="saveBox">
                <el-button type="primary" :loading="btnLoading" class="add" @click="addGoods()">添加</el-button>
            </div>
        </div>
    </div>
</template>

<script>
// 引入富文本编辑器
import editor from '../../components/common/editor.vue';
import headerNotice from '../../components/common/headerNotice.vue';
export default {
  name: "baseSetting",
  components: {
      headerNotice,
    "v-editor": editor
  },
    data() {
        return {
            loading: false,
            items: {},
            formData: {
                "contents":"",
                "itemCode": "",
                "title": "",
                "cate": 0,
                "type": 0,
                "status": 1,
                "images": [],
                "description":'',
                "descripImages": [],
            },
            cateList: [
                {
                    value: 0,
                    label: "请选择"
                },
                    {
                    value: 1,
                    label: "游戏类"
                },
                {
                    value: 2,
                    label: "化妆品"
                },
                 {
                    value: 3,
                    label: "食品"
                },
            ],
           typeList: [
                {
                    value: 0,
                    label: "请选择"
                },
                    {
                    value: 1,
                    label: "热门"
                },
                {
                    value: 2,
                    label: "精选"
                },
                 {
                    value: 3,
                    label: "普通"
                },
           ],
            cateLoading:false,
            baseUrl: this.$store.state.URL,
            accept:".jpg,.jpeg,.png,.JPG,.JPEG,.PNG",
            uploadAction: this.$store.state.apiUrl + '/api/services/app/Image/TxCloudUploadImage',//上传的服务器api地址
            headers: {
                'Authorization': localStorage.getItem('accessToken'),
            },
            value: '',
            goodsImagesList: [],//商品相册file-list
            goodsDescripImagesList: [],//商品详情图片file-list
            uploadIndex: 0,//上传规格图片的index
            btnLoading: false,//添加按钮loading
        }
    },
    mounted() {
        
    },
    methods: {
        handleExceed() {
            this.$message.error('抱歉，最多上传一张图片！');
        },
        beforeUpload(file) {
            debugger
           let what= this.$store.state.URL;
           let shif=this.$store.state.apiUrl ;
            const isLt2M = file.size / 1024 / 1024 < 1;
            if (file.type != 'image/jpeg' && file.type != 'image/png') {
                this.$message.error('上传的图片只支持JPG/PNG 的格式!');
                return false;
            }
            if (!isLt2M) {
                this.$message.error('上传图片大小不能超过 1MB!');
            }
            return isLt2M;
        },
        //商品相册上传
        handleGoodsImgstSuccess(response, file, fileList) {
            this.formData.images.push(response.result.fileName);
            this.goodsImagesList.push({
                name: response.result.fileName,
                url: this.baseUrl + response.result.url
            });
        },
        //商品相册移除某张
        handleGoodsImgstRemove(file, fileList) {
            let self = this;
            this.goodsImagesList = fileList;
            this.formData.images = [];
            this.goodsImagesList.forEach(function (ele, index) {
                self.formData.images.push(ele.name)
            });
        },
        //商品详情图片上传
        handleGoodsDescripImgstSuccess(response, file, fileList) {
            this.formData.descripImages.push(response.result.fileName);
            this.goodsDescripImagesList.push({
                name: response.result.fileName,
                url: this.baseUrl + response.result.url
            });
        },
        //商品详情图片移除
        handleGoodsDescripImgstRemove(file, fileList) {
            let self = this;
            this.goodsDescripImagesList = fileList;
            this.formData.descripImages = [];
            this.goodsDescripImagesList.forEach(function (ele, index) {
                self.formData.descripImages.push(ele.name)
            });
        },
        //点击上传按钮 获取该条index
        uploadBtn(index) {
            this.uploadIndex = index;
        },
        //规格上传图片成功事件处理
        handleSpeSuccess(response, file, fileList) {
            this.formData.propList[this.uploadIndex].fileName = response.result.fileName;
            // this.formData.propList[this.uploadIndex].imgUrl = response.result.url;
        },


        //添加商品
        addGoods() {
            let self = this;
            this.btnLoading = true;
            // if ( !this.formData.unit || !this.formData.title) {
            //     self.$message.error('请检查必填项是否填写！');
            //     self.btnLoading = false;
            //     return
            // }
            self.formData.entImage=self.formData.images.toString();
             self.formData.image=self.formData.descripImages.toString();
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/ThemeService/Create",
                data: this.formData,
                success(res) {
                    self.$message({
                        message: '添加成功',
                        type: 'success'
                    });
                    self.$router.push({
                        'path': '/ThemeList'
                    })
                    self.btnLoading = false;
                },
                fail(res) {
                    self.btnLoading = false;
                }
            })
        },
    //切换
      changeTheme(val) {
       console.log(val)
       this.formData.productLinkType=val;
      },
        Customization(that){
             let self = this ;
            if(that==false){
               self.IsCustomized=false;
            }else{
               self.IsCustomized=true;
            }
          
        }
    }
}
</script>

<style lang='scss' scoped>
// 基本信息
.baseInfo {
    margin: 20px 50px;
    border: 1px solid #c5c5c5;
    h1 {
        background: #f3f3f3;
        padding: 10px 20px;
        span {
            font-size: 12px;
            color: #999;
            i {
                font-style: normal;
            }
        }
    }
    .table {
        margin-top: 20px;
        .displayCate {
            display: flex;
            flex-direction: column;
            border: 1px solid #999;
            li {
                display: flex;
                flex-direction: column;
                border-bottom: 1px solid #999;
                box-sizing: border-box;
                padding: 0 20px;
                &:nth-last-child(1){
                    border: none;
                }
                .firstName {
                    font-size: 18px;
                    color: #000;
                }
                .groupBox {
                    padding-left: 40px;
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    /deep/ .radio {
                        margin: 0 20px 10px 0;
                    }
                }
            }
        }
    }
    .goodsBox {
        padding: 20px;
    }
    .specification {
        margin-top: 20px;
        width: 100%;
        box-sizing: border-box;
        padding: 0 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        table {
            width: 100%;
            table-layout: fixed;
            word-break: break-all;
            border: 1px solid #ccc;
            thead {
                width: 100%;
                th {
                    height: 50px;
                    font-size: 14px;
                    color: #666;
                    border: 1px solid #ccc;
                }
            }
            tbody tr {
                border: 1px solid #ccc;
                td {
                    height: 50px;
                    border: 1px solid #ccc;
                    vertical-align: middle;
                    text-align: center;
                    textarea {
                        width: 80%;
                        appearance: none;
                        outline: none;
                        border: none;
                        min-height: 100px;
                        background: #F9F9F9;
                        resize: none;
                    }
                    input {
                        text-align: center;
                        width: 95%;
                        height: 80%;
                        outline: none;
                        border: none;
                        background: #f9f9f9;
                    }
                    img {
                        display: inline-block;
                        width: 100px;
                        height: 100px;
                        cursor: pointer;
                    }
                    &.spePic {
                        padding: 10px;
                    }
                }
            }
        }
        .addSpecification {
            margin: 20px 0;
        }
    }
    .saveBox {
        border-top: 1px solid #c5c5c5;
        width: 100%;
        padding: 20px 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .linkIpt {
        padding: 15px 50px;
    }
    .direct{
        width: 20%;
    }
    .inlineBl{
        display: inline-block;
    }
}
</style>
<style>
</style>
